export default __webpack_public_path__ + "static/media/128.a4f54b90.gif";